import { uniqBy } from "lodash"

import useTenantLanguages from "hooks/useTenantLanguages"
import Language from "models/Language"
import { useTenantSettings } from "stores/tenantSettings"

interface IUseTranslationsTenantLanguagesProps {
    mandatoryTranslationIsoCodes?: string[]
    showAllPossibleLanguages?: boolean
}

export default function useTranslationsTenantLanguages({
    mandatoryTranslationIsoCodes,
    showAllPossibleLanguages,
}: IUseTranslationsTenantLanguagesProps) {
    const {
        tenantSettingsLanguages: {
            primaryLanguage,
            maintainableLanguages,
        }
    } = useTenantSettings()
    const { tenantLanguages } = useTenantLanguages()

    const mandatoryLanguages = uniqBy([
        ...(mandatoryTranslationIsoCodes?.map(isoCode => {
            return tenantLanguages?.find(language => language.isoCode === isoCode)
        }).filter((language) => !!language) || []) as Language[],
        // primaryLanguage,
    ], language => language.isoCode)

    const optionalLanguages = (showAllPossibleLanguages ? (tenantLanguages || []) : [primaryLanguage, ...maintainableLanguages])
        .filter(language => {
            return !mandatoryLanguages.some(mandatoryLanguage => mandatoryLanguage.isoCode === language.isoCode)
        })

    const allLanguages = uniqBy([
        ...mandatoryLanguages,
        ...optionalLanguages,
    ], language => language.isoCode)

    function isTranslationOptional(isoCode: string) {
        return !mandatoryTranslationIsoCodes?.includes(isoCode)
    }

    function isFirstOptionalLanguageAfterMandatoryLanguage(isoCode: string) {
        return mandatoryLanguages.length > 0
            && optionalLanguages[0]?.isoCode === isoCode
    }

    return {
        languages: allLanguages,
        isTranslationOptional,
        isFirstOptionalLanguageAfterMandatoryLanguage,
    }
}
